import { DriverBlocksService } from '@/backend/market'
import { DriverBlockRepository } from '../../domain/repositories/DriverBlockRepository'
import { DriverBlockModel } from '../models/DriverBlockModel'
import type { DriverBlockFilterEntity } from '../../domain/entities/DriverBlockFilterEntity'
import { DriverBlockFilterModel } from '../models/DriverBlockFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverBlockEntity } from '../../domain/entities/DriverBlockEntity'
import type { CreateUpdateDriverBlockEntity } from '../../domain/entities/CreateUpdateDriverBlockEntity'
import { CreateUpdateDriverBlockModel } from '../models/CreateUpdateDriverBlockModel'

export class DriverBlockRepositoryImpl implements DriverBlockRepository {
  async getDriverBlock(
    filterData: DriverBlockFilterEntity
  ): Promise<PaginateEntity<DriverBlockEntity[]> | { error: true }> {
    const driverBlockFilterModel = new DriverBlockFilterModel(filterData)
    try {
      const response = await DriverBlocksService.getDriverBlocksAdmin(driverBlockFilterModel)
      const driverBlockModels = response.items?.map((item) => new DriverBlockModel(item))
      const result = new PaginateEntity<DriverBlockEntity[]>(response, driverBlockModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getActiveDriverBlock(driverId: number): Promise<DriverBlockEntity | { error: true }> {
    try {
      const response = await DriverBlocksService.getActiveDriverBlockAdmin({
        driverId
      })
      const driverBlockModel = new DriverBlockModel(response)

      return driverBlockModel
    } catch {
      return { error: true }
    }
  }
  async createDriverBlock(
    blockData: CreateUpdateDriverBlockEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDriverBlockModel = new CreateUpdateDriverBlockModel(blockData)
    try {
      await DriverBlocksService.postDriverBlockAdmin({
        requestBody: createUpdateDriverBlockModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateDriverBlock(
    id: number,
    blockData: CreateUpdateDriverBlockEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateDriverBlockModel = new CreateUpdateDriverBlockModel(blockData)
    try {
      await DriverBlocksService.putDriverBlockAdmin({
        id,
        requestBody: createUpdateDriverBlockModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
